/* eslint-disable
    no-undef,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import OrgPropertiesConstants from 'constants/OrgPropertiesConstants'
import _cloneDeep from 'lodash/cloneDeep'

const OrgPropertiesStore = Marty.createStore({
  id: 'OrgPropertiesStore',

  getInitialState() {
    return {
      settingsByOrgId: {},
      // org logos grouped by ID
      orgLogoUploadsById: {},
      orgLogoUploadsStateById: {},

      // generic org images grouped by a string key
      orgImageUploadsByType: {},
      orgImageUploadsStateByType: {}
    }
  },

  handlers: {
    fetchSettingsDone: OrgPropertiesConstants.FETCH_ORG_PROPERTIES_DONE,
    updateSettingsDone: OrgPropertiesConstants.UPDATE_ORG_PROPERTIES_DONE,
    uploadOrgLogo: OrgPropertiesConstants.UPLOAD_ORG_LOGO_STARTING,
    uploadOrgLogoDone: OrgPropertiesConstants.UPLOAD_ORG_LOGO_DONE,
    uploadOrgImage: OrgPropertiesConstants.UPLOAD_ORG_IMAGE_STARTING,
    uploadOrgImageDone: OrgPropertiesConstants.UPLOAD_ORG_IMAGE_DONE
  },

  setSettingForOrgId(orgId, settings) {
    const settingsByOrgId = _.cloneDeep(this.state.settingsByOrgId)
    settingsByOrgId[orgId] = settings
    return this.setState({ settingsByOrgId })
  },

  fetchSettingsDone(orgId, settings) {
    return this.setSettingForOrgId(orgId, settings)
  },

  updateSettingsDone(orgId, settings) {
    return this.setSettingForOrgId(orgId, settings)
  },

  fetchPropertiesForOrg(orgId) {
    return this.fetch({
      id: `fetchPropertiesForOrg${ orgId }`,
      locally() {
        return this.state.settingsByOrgId[orgId]
      },
      remotely() {
        return this.app.queries.OrgPropertiesQueries.fetchProperties(orgId)
      }
    })
  },

  refetchPropertiesForCurrentOrg() {
    return this.fetch({
      id: 'refetchPropertiesForCurrentOrg',
      dependsOn: this.app.stores.OrgStore.getOrFetchCurrentOrg(),
      locally() {
        return null
      },
      remotely() {
        return this.app.queries.OrgPropertiesQueries.fetchProperties(__guard__(this.app.stores.OrgStore.getCurrentOrg(), x => x.id))
      }
    })
  },

  fetchPropertiesForCurrentOrg() {
    return this.fetch({
      id: 'fetchPropertiesForCurrentOrg',
      dependsOn: this.app.stores.OrgStore.getOrFetchCurrentOrg(),
      locally() {
        return this.state.settingsByOrgId[__guard__(this.app.stores.OrgStore.getCurrentOrg(), x => x.id)]
      },
      remotely() {
        return this.app.queries.OrgPropertiesQueries.fetchProperties(__guard__(this.app.stores.OrgStore.getCurrentOrg(), x => x.id))
      }
    })
  },

  getOrgLogoUploadsStateById() {
    return this.state.orgLogoUploadsStateById
  },

  getOrgLogoUploadsById() {
    return this.state.orgLogoUploadsById
  },

  getOrgImageUploadsByType() {
    return this.state.orgImageUploadsByType
  },

  getOrgImageUploadsStateByType() {
    return this.state.orgImageUploadsStateByType
  },

  // TODO: treat orgLogo as just another OrgImage
  uploadOrgLogo(orgId, file, fileId) {
    if (fileId != null) {
      const uploadsById = _cloneDeep(this.state.orgLogoUploadsById)
      uploadsById[fileId] = null
      const uploadsStateById = _cloneDeep(this.state.orgLogoUploadsStateById)
      uploadsStateById[fileId] = OrgPropertiesConstants.UPLOAD_ORG_LOGO_STARTING
      return this.setState({ orgLogoUploadsById: uploadsById, orgLogoUploadsStateById: uploadsStateById })
    }
  },

  uploadOrgLogoDone(orgId, url, fileId) {
    if (fileId != null) {
      const uploadsById = _cloneDeep(this.state.orgLogoUploadsById)
      uploadsById[fileId] = url
      const uploadsStateById = _cloneDeep(this.state.orgLogoUploadsStateById)
      uploadsStateById[fileId] = OrgPropertiesConstants.UPLOAD_ORG_LOGO_DONE
      return this.setState({ orgLogoUploadsById: uploadsById, orgLogoUploadsStateById: uploadsStateById })
    }
  },

  uploadOrgImage(orgId, file, imageType) {
    if (typeof fileId !== 'undefined' && fileId !== null) {
      const orgImageUploadsByType = _.cloneDeep(this.state.orgImageUploadsByType)
      orgImageUploadsByType[imageType] = null
      const orgImageUploadsStateByType = _.cloneDeep(this.state.orgImageUploadsStateByType)
      orgImageUploadsStateByType[imageType] = OrgPropertiesConstants.UPLOAD_ORG_IMAGE_STARTING
      return this.setState({ orgImageUploadsByType, orgImageUploadsStateByType })
    }
  },

  uploadOrgImageDone(orgId, imageUrl, imageType) {
    const orgImageUploadsByType = _.cloneDeep(this.state.orgImageUploadsByType)
    orgImageUploadsByType[imageType] = imageUrl
    const orgImageUploadsStateByType = _.cloneDeep(this.state.orgImageUploadsStateByType)
    orgImageUploadsStateByType[imageType] = OrgPropertiesConstants.UPLOAD_ORG_IMAGE_DONE
    return this.setState({ orgImageUploadsByType, orgImageUploadsStateByType })
  }

})

export default OrgPropertiesStore

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}



// WEBPACK FOOTER //
// ./src/scripts/stores/OrgPropertiesStore.js